import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";
import apiRequestType from "../apiRequestType";

const getExistingQuizImages = (data, customConfig) => {
  return apiRequestType(
    apiTypes.POST,
    apiConstants.MANAGE.GET_EXISTING_QUIZ_IMAGES,
    data,
    null,
    customConfig
  );
};

export default getExistingQuizImages;
